import { lazy, Suspense, useLayoutEffect, useMemo, useState } from 'react';
import FunctionComponentWithRef from '@hei/function-component-with-ref';
import { GlobalStyles } from './Main.styles';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import getInitialPageData from '@utils/getInitialPageData';

const Error = lazy(() => import(/* webpackChunkName: 'error-page', webpackPreload: true */ '@components/Error'));
const LandingPage = lazy(
  () => import(/* webpackChunkName: 'landing-page', webpackPreload: true */ '@components/LandingPage')
);

export interface MainProps {
  className?: string;
}

const Main = FunctionComponentWithRef<MainProps>(() => {
  const [googleKey, setGoogleKey] = useState('');

  const errorPage = useMemo(
    () => (
      <Suspense fallback={null}>
        <Error />
      </Suspense>
    ),
    []
  );

  const landingPage = useMemo(
    () => (
      <Suspense fallback={null}>
        <LandingPage googleKey={googleKey} />{' '}
      </Suspense>
    ),
    [googleKey]
  );

  useLayoutEffect(() => {
    getInitialPageData().then(setGoogleKey);
  }, []);

  return (
    <>
      <GlobalStyles />

      <Router>
        <Routes>
          <Route path="Error" element={errorPage} />
          <Route path="*" element={landingPage} />
        </Routes>
      </Router>
    </>
  );
});

export default Main;
